import React from 'react'
import styles from './styles.module.css'
import { PALETTE } from '../../../styles/constants'

// CSS-based skeleton loader (task #76).
//
// Previously this rendered a full react-content-loader <svg> (gradient defs,
// clip-path, animated <rect>) for EVERY instance. Text/withLoader emitted one
// per Text on the page — ~340 on /us/shop — even for Text that was NOT loading,
// costing ~283 KB of duplicate DOM. It is now a single shimmering <div> whose
// animation lives ONCE in the stylesheet (CSS Modules scopes the class + the
// keyframes name), so N loaders share one keyframes rule and each adds only a
// single element.
//
// `uniqueKey` is accepted for API compatibility with the old signature but is no
// longer needed: a CSS skeleton has no per-instance ids, so there is nothing to
// keep deterministic across SSR/client — the markup is identical by construction.
function MyLoader({ isLoading, uniqueKey }) {
  // Only emit the skeleton when actually loading. isLoading is deterministic
  // server==client for every call site (price Text keys off SSR-hydrated
  // namedPricesFetched; ShopItem keys off shopItemsLoading), so conditionally
  // rendering it introduces no hydration mismatch.
  if (!isLoading) {
    return null
  }
  return (
    <div
      className={styles.loader}
      aria-hidden="true"
      style={{ '--loader-gray-50': PALETTE.gray50, '--loader-gray-100': PALETTE.gray100 }}
    />
  )
}

export default MyLoader
